import Keycloak from 'keycloak-js';

// Configuration from environment variables
const keycloakUrl = import.meta.env.VITE_KEYCLOAK_URL;
const keycloakRealm = import.meta.env.VITE_KEYCLOAK_REALM || 'dserver.by';
const keycloakClientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'dsc-app';

if (!keycloakUrl) {
  throw new Error(
    'VITE_KEYCLOAK_URL is required. Set it in environment variables.',
  );
}

// Create Keycloak instance
export const keycloak = new Keycloak({
  url: keycloakUrl,
  realm: keycloakRealm,
  clientId: keycloakClientId,
});

// Token persistence in localStorage
const TOKEN_KEYS = {
  token: 'kc_token',
  refreshToken: 'kc_refreshToken',
  idToken: 'kc_idToken',
};

export function saveTokens() {
  if (keycloak.token) localStorage.setItem(TOKEN_KEYS.token, keycloak.token);
  if (keycloak.refreshToken)
    localStorage.setItem(TOKEN_KEYS.refreshToken, keycloak.refreshToken);
  if (keycloak.idToken)
    localStorage.setItem(TOKEN_KEYS.idToken, keycloak.idToken);
}

export function clearTokens() {
  Object.values(TOKEN_KEYS).forEach((k) => localStorage.removeItem(k));
}

export function isE2ETokenAuthEnabled() {
  return import.meta.env.VITE_E2E_TOKEN_AUTH === '1';
}

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEYS.token);
}

function loadTokens(): Partial<Keycloak.KeycloakInitOptions> {
  const token = localStorage.getItem(TOKEN_KEYS.token);
  const refreshToken = localStorage.getItem(TOKEN_KEYS.refreshToken);
  const idToken = localStorage.getItem(TOKEN_KEYS.idToken);
  if (token && refreshToken)
    return { token, refreshToken, idToken: idToken || undefined };
  return {};
}

// Initialize options
export const initOptions: Keycloak.KeycloakInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
  pkceMethod: 'S256',
  silentCheckSsoRedirectUri:
    window.location.origin + '/silent-check-sso.html',
  ...loadTokens(),
};

// Token refresh interval (1 minute before expiry)
export const TOKEN_REFRESH_INTERVAL = 60000;

// Minimum validity in seconds for token refresh
export const MIN_TOKEN_VALIDITY = 70;
